import React from 'react';
import { Typography, Box } from '@mui/material';

const AdminKooperation: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 4, fontWeight: 700 }}>
        Kooperation verwalten
      </Typography>
      {/* TODO: Implement cooperation CRUD interface */}
      <Typography>Kooperation Management Interface kommt hier...</Typography>
    </Box>
  );
};

export default AdminKooperation;
